import fetch from '../../utils/fetch';

export function error(error) {
    return { type: 'SONG_LIST_ERROR', error };
}

export function loading(loading) {
    return { type: 'SONG_LIST_LOADING', loading };
}

export function success(data) {
    return { type: 'SONG_LIST_SUCCESS', data };
}

export function list(page = '/songs') {
    return dispatch => {
        dispatch(loading(true));
        dispatch(error(''));

        fetch(page)
            .then(response => response.json())
            .then(data => {
                dispatch(loading(false));
                dispatch(success(data));
            })
            .catch(e => {
                dispatch(loading(false));
                dispatch(error(e.message));
            });
    };
}

export function all(page = '/songs/all') {
    return dispatch => {
        dispatch(loading(true));
        dispatch(error(''));

        fetch(page)
            .then(response => response.json())
            .then(data => {
                dispatch(loading(false));
                dispatch(success(data));
            })
            .catch(e => {
                dispatch(loading(false));
                dispatch(error(e.message));
            });
    };
}

export function reset() {
    return { type: 'SONG_LIST_RESET' };
}



// WEBPACK FOOTER //
// ./src/actions/song/list.js